import { EventType } from '../../../../App.types'
import { Trainer } from '../../ActivityDetails.types'

import MultipleTrainers from './MultipleTrainers'
import SingleTrainer from './SingleTrainer'

interface Props {
  trainers: Array<Trainer>
  eventType: EventType
}

const Trainers = ({ trainers, eventType }: Props) => {
  if (!trainers.length) return null

  if (trainers.length === 1) {
    return <SingleTrainer trainer={trainers[0]} eventType={eventType} />
  }

  return <MultipleTrainers trainers={trainers} eventType={eventType} />
}

export default Trainers
